"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexToGraph = exports.indicesToContextGraph = exports.indicesToGraph = exports.mergeEntityGraphs = exports.mergeEntityContextGraphs = exports.dedupeIndices = exports.getIndexMapByType = exports.getChildrenFromGraph = exports.contextToIndex = exports.populateGraph = exports.getStringifiedId = exports.hashDomainObjectIndex = void 0;
const core_1 = require("@newfront-insurance/core");
function hashDomainObjectIndex(index) {
    return `${index.type}_${index.id}`;
}
exports.hashDomainObjectIndex = hashDomainObjectIndex;
function initializeGraphNode(graph, index) {
    const stringifiedId = getStringifiedId(index.id);
    if (!graph[index.type]) {
        graph[index.type] = {};
    }
    if (!graph[index.type][stringifiedId]) {
        graph[index.type][stringifiedId] = [];
    }
    return graph;
}
function getStringifiedId(id) {
    return String(id);
}
exports.getStringifiedId = getStringifiedId;
function populateGraph(graph, parent, children = [], keepChildrenContext = false) {
    initializeGraphNode(graph, parent);
    const stringifiedId = getStringifiedId(parent.id);
    const existingChildrenKeys = new Set(getChildrenFromGraph(graph, parent).map((childContext) => hashDomainObjectIndex(childContext)));
    children
        .filter((childContext) => !existingChildrenKeys.has(hashDomainObjectIndex(childContext)))
        .forEach((childContext) => {
        graph[parent.type][stringifiedId].push(keepChildrenContext ? childContext : contextToIndex(childContext));
        populateGraph(graph, childContext);
    });
    return graph;
}
exports.populateGraph = populateGraph;
function contextToIndex(context) {
    return {
        id: context.id,
        type: context.type,
    };
}
exports.contextToIndex = contextToIndex;
function getChildrenFromGraph(graph, index) {
    const id = getStringifiedId(index.id);
    if (graph[index.type] && graph[index.type][id]) {
        return graph[index.type][getStringifiedId(index.id)];
    }
    return [];
}
exports.getChildrenFromGraph = getChildrenFromGraph;
function getIndexMapByType(indices) {
    return core_1.toGroupedMap(dedupeIndices(indices), (index) => index.type);
}
exports.getIndexMapByType = getIndexMapByType;
function dedupeIndices(indices) {
    const map = core_1.toMap(indices, (index) => hashDomainObjectIndex(index));
    return [...map.values()];
}
exports.dedupeIndices = dedupeIndices;
function mergeGraphs(graphs, keepChildContext = false) {
    return graphs.reduce((graph, subGraph) => {
        const types = Object.keys(subGraph);
        types.forEach((type) => {
            const ids = Object.keys(subGraph[type]);
            ids.forEach((id) => {
                const children = subGraph[type][id] || [];
                populateGraph(graph, { type, id }, children, keepChildContext);
                children.forEach((child) => populateGraph(graph, child));
            });
        });
        return graph;
    }, {});
}
function mergeEntityContextGraphs(...graphs) {
    return mergeGraphs(graphs, true);
}
exports.mergeEntityContextGraphs = mergeEntityContextGraphs;
function mergeEntityGraphs(...graphs) {
    return mergeGraphs(graphs);
}
exports.mergeEntityGraphs = mergeEntityGraphs;
function indicesToGraph(indices) {
    return mergeEntityGraphs(...indices.map((index) => indexToGraph(index)));
}
exports.indicesToGraph = indicesToGraph;
function indicesToContextGraph(indices) {
    return indicesToGraph(indices);
}
exports.indicesToContextGraph = indicesToContextGraph;
function indexToGraph(index) {
    return {
        [index.type]: {
            [getStringifiedId(index.id)]: [],
        },
    };
}
exports.indexToGraph = indexToGraph;
//# sourceMappingURL=util.js.map